import { BranchOfficeDto } from '@/api';
import { _address } from '@/constants/Address';

export const _branchOffice = {
  id: '',
  name: '',
  branchNumber: 0,
  address: _address,
} as BranchOfficeDto;
